<template>
  <div class="header">
    <div class="header-content">
      <div class="logo-wrap">
        <img class="g-icon logo" src="./imgs/logo.png" />新华网循证医保鉴证核查平台
      </div>
      <div class="nav-wrap">
        <ul>
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="{active: navActive===index}"
            @click="navClick(item,index)"
          >{{item.name}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "g-header",
  props: {
    navActive: {
      type: Number
    }
  },
  data() {
    return {
      navList: [
        {
          name: "关于平台",
          url: "/index"
        },
        {
          name: "服务模式",
          url: "/service"
        },
        {
          name: "合作对接",
          url: "/cooperation"
        },
        {
          name: "平台演示",
          url: 'http://promotion.mashangchayao.com/#/login'
        }
      ]
    };
  },
  methods: {
    navClick(item, index) {
      if (index === 3) {
        // let url = window.location.href;
        // let t = url.split("/#/");
        // let s = t[0] + "/#/show";
        window.open(item.url, "_blank");
      } else {
        this.$router.replace(item.url);
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.header {
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;

  .header-content {
    max-width: 1440px;
    min-width: 1200px;
    margin: 0 auto;
    height: 60px;
    position: relative;

    .logo-wrap {
      height: 60px;
      line-height: 60px;
      font-size: 24px;
      font-weight: bold;

      .logo {
        width: 65px;
        height 40px
        margin-right: 8px;
      }
    }

    .nav-wrap {
      position: absolute;
      right: 0;
      top: 0;

      ul {
        li {
          display: inline-block;
          vertical-align: top;
          line-height: 60px;
          font-size: 16px;
          margin-right: 78px;
          cursor: pointer;
          position: relative;

          &:last-child {
            margin-right: 0;
          }

          &.active, &:hover {
            &:after {
              content: '';
              position: absolute;
              bottom: 7px;
              left: 0;
              right: 0;
              height: 4px;
              background-color: #1b57ec;
              border-radius: 2px;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/g-header/index.vue